module.exports = __webpack_public_path__ + "img/logo.31744a62.svg";